module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgNiAyNCI+CiAgICA8cGF0aCBmaWxsPSIjQkRDNkNGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDNhMyAzIDAgMSAxIDYgMCAzIDMgMCAwIDEtNiAwem0wIDlhMyAzIDAgMSAxIDYgMCAzIDMgMCAwIDEtNiAwem0wIDlhMyAzIDAgMSAxIDYgMCAzIDMgMCAwIDEtNiAweiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_vertical.svg
// module id = JjWH
// module chunks = 1